import React from 'react'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'

const Warning = ({ block }) => {
    return (
        <div className="baseocom-warning-block">
            <div className="baseocom-icon">{icon('warning')}</div>
            <div className="baseocom-content-text">
                {block?.content && <p>{block?.content}</p>}
                {block?.childrens && (
                    <Parser content_block={block?.childrens} attributes={block?.attributes} />
                )}
            </div>
        </div>
    )
}

export default Warning
